import util from '../util'

let controller = 'SubparceiroConta'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  ListarVinculo(dto) {
    return util.Axios.GetAll(`${controller}/vinculo`, dto)
  },
  Desvincular(codigo) {
    return util.Axios.Post(`${controller}/${codigo}/desvincular`)
  },
  ListarHistorico: function (dto, options){
    if (options && options.data) dto.data = options.data

    return util.Axios.GetAll(controller + '/historico', dto)
  }
})
